export default "__VITE_ASSET__zWYNyFAS__$_?url__"